import styled from "styled-components";
import { flex, responsive } from "../../mixins";

export const Wrapper = styled.section`
  .projects-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 20rem;
    gap: 2rem;
  }
  .carousel-container {
    transition: var(--transition);
  }
`;
export const Header = styled.div`
  ${responsive.mobile.standard`
  ${flex()}
  margin-bottom:1rem;
`}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  transition: var(--transition);
`;
